'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _footer = require('./footer.styles');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var PageNumber = function PageNumber(_ref) {
  var num = _ref.num,
    _onClick = _ref.onClick,
    currentPage = _ref.currentPage;
  return _react2.default.createElement(_footer.PageNumberCol, null, _react2.default.createElement(_footer.PageNumberContainer, {
    onClick: function onClick() {
      return _onClick(num);
    }
  }, _react2.default.createElement(_footer.PageNumberTypography, {
    current: currentPage === num
  }, num), currentPage === num && _react2.default.createElement(_footer.PageNumberUnderScore, null)));
};
exports.default = PageNumber;